import * as lib from '~/dependencies';

export const ThumbsContainer = lib.styled.aside`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 8px;
  padding: 8px 0 4px;
`;

export const Thumb = lib.styled.div`
  display: inline-flex;
  flex-shrink: 0;
  border-radius: 4px;
  padding: 2px;
  box-sizing: border-box;
  position: relative;

  &:not(:hover) button {
    opacity: 0;
    pointer-events: none;
  }
`;

export const RemoveImageButton = lib.styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: transparent;
  border: none;
  color: rgba(0, 0, 0, 0.45);
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  line-height: 1;

  &:active {
    transform: scale(0.92);
  }
`;

export const ThumbInner = lib.styled.div`
  display: flex;
  min-width: 0;
  overflow: hidden;
`;

export const ThumbImage = lib.styled.img`
  display: block;
  width: 64px;
  height: 64px;
  border-radius: 4px;
  object-fit: cover;
`;

export const NonImagePreview = lib.styled.div`
  width: 64px;
  height: 64px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #f7f7f7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 6px;
  overflow: hidden;
`;

export const NonImageBadge = lib.styled.span`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  background: #e6eef9;
  color: #2e4a73;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  margin-bottom: 8px;
`;

export const NonImageName = lib.styled.span`
  max-width: 100%;
  color: #555;
  font-size: 10px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ThumbMoreOverlay = lib.styled.div`
  position: absolute;
  inset: 0;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
`;
